(() => {
  if (window.semboniaReelReady) return;
  window.semboniaReelReady = true;
  const instances = new Map();
  function setup(element) {
    if (instances.has(element)) return;
    const slider = element.querySelector('[id^="Slider-"]');
    const slides = [...element.querySelectorAll('.slideshow__slide')];
    if (!slider || !slides.length) return;
    const abort = new AbortController();
    const listen = (target, type, fn, options = {}) => target.addEventListener(type, fn, { ...options, signal: abort.signal });
    const segments = [...element.querySelectorAll('[data-reel-index]')];
    const toggle = element.querySelector('.sembonia-reel__toggle');
    const duration = Math.max(1, Number(slider.dataset.speed) || 5) * 1000;
    let current = 0, elapsed = 0, previousTime = 0, frame, playing = false, inView = true;
    let scrollTimer, scrolling = false, touching = false;
    function paint() {
      segments.forEach((button, index) => {
        button.querySelector('.sembonia-reel__fill').style.transform =
          'scaleX(' + (index < current ? 1 : index === current ? elapsed / duration : 0) + ')';
        if (index === current) button.setAttribute('aria-current', 'true');
        else button.removeAttribute('aria-current');
      });
      slides.forEach((slide, index) => {
        slide.setAttribute('aria-hidden', String(index !== current));
        slide.inert = index !== current;
      });
    }
    function go(index, instant = false) {
      current = (index + slides.length) % slides.length;
      elapsed = 0;
      previousTime = 0;
      slider.scrollTo({ left: slides[current].offsetLeft - slides[0].offsetLeft, behavior: instant ? 'instant' : 'smooth' });
      paint();
    }
    function tick(time) {
      if (playing && !scrolling && !touching && inView && !document.hidden && element.getBoundingClientRect().width > 0) {
        if (previousTime) elapsed += Math.min(time - previousTime, 100);
        if (elapsed >= duration) go(current + 1);
        paint();
      }
      previousTime = time;
      frame = requestAnimationFrame(tick);
    }
    function setPlaying(value) {
      playing = value && slides.length > 1;
      previousTime = 0;
      element.toggleAttribute('data-reel-playing', playing);
      slider.setAttribute('aria-live', playing ? 'off' : 'polite');
      toggle?.setAttribute('aria-label', playing ? 'Pause slideshow' : 'Play slideshow');
    }
    // Preserve the existing theme-editor interface.
    element.slider = slider;
    element.pause = () => setPlaying(false);
    element.play = () => setPlaying(true);
    element.autoplayButtonIsSetToPlay = slider.dataset.autoplay === 'true';
    listen(element, 'click', event => {
      const button = event.target.closest('button');
      if (!button || !element.contains(button)) return;
      if (button.hasAttribute('data-reel-index')) go(Number(button.dataset.reelIndex));
      else if (button.hasAttribute('data-reel-step')) go(current + Number(button.dataset.reelStep));
      else if (button === toggle) {
        setPlaying(!playing);
        element.autoplayButtonIsSetToPlay = playing;
      } else return;
      event.preventDefault();
    });
    listen(element, 'keydown', event => {
      if (!['ArrowLeft', 'ArrowRight'].includes(event.key) || /INPUT|TEXTAREA|SELECT/.test(event.target.tagName)) return;
      event.preventDefault();
      go(current + (event.key === 'ArrowRight' ? 1 : -1));
    });
    // Native horizontal touch scrolling remains enabled; never intercept vertical gestures.
    function syncVisibleSlide() {
      clearTimeout(scrollTimer);
      scrolling = false;
      if (!slider.clientWidth) return;
      const offset = slider.scrollLeft + slides[0].offsetLeft;
      const index = slides.reduce((best, slide, i) => Math.abs(slide.offsetLeft - offset) < Math.abs(slides[best].offsetLeft - offset) ? i : best, 0);
      if (index !== current) { current = index; elapsed = 0; }
      previousTime = 0;
      paint();
    }
    // Older iPhone Safari versions do not emit scrollend. Settle from regular
    // scroll events too, including native swipes, momentum and scroll snapping.
    listen(slider, 'scroll', () => {
      scrolling = true;
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(syncVisibleSlide, 160);
    }, { passive: true });
    listen(slider, 'scrollend', syncVisibleSlide);
    listen(slider, 'touchstart', () => { touching = true; }, { passive: true });
    const endTouch = () => {
      touching = false;
      previousTime = 0;
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(syncVisibleSlide, 160);
    };
    listen(slider, 'touchend', endTouch, { passive: true });
    listen(slider, 'touchcancel', endTouch, { passive: true });
    const resize = new ResizeObserver(() => {
      if (slider.clientWidth) go(current, true);
    });
    resize.observe(slider);
    const visibility = new IntersectionObserver(entries => {
      inView = entries[0].isIntersecting;
      previousTime = 0;
    });
    visibility.observe(element);
    setPlaying(element.autoplayButtonIsSetToPlay);
    paint();
    frame = requestAnimationFrame(tick);
    instances.set(element, () => { abort.abort(); resize.disconnect(); visibility.disconnect(); cancelAnimationFrame(frame); clearTimeout(scrollTimer); });
  }
  const scan = () => document.querySelectorAll('[data-sembonia-reel]').forEach(setup);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, { once: true });
  else scan();
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach((destroy, element) => {
      if (event.target.contains(element)) { destroy(); instances.delete(element); }
    });
  });
})();
